import { Flex, Button, ModalV2, Text, toast } from "@jsq/ds/core";
import { useEnableComplianceMutation } from "~/graphql/supergraphHooks";
import { SPACING } from "~/styles/variables";
import { toGlobalId } from "~/utils/graphql-helpers";
import { ProgramsType } from "../types";

type Props = {
  allPrograms: ProgramsType;
  arenaId: string;
  entityId: string;
  entityName: string;
  showModal: boolean;
  entityProgram: string;
  newValue: string;
  onClose: () => void;
};

const EnableComplianceWarningModal = ({
  allPrograms,
  arenaId,
  entityId,
  entityName,
  showModal,
  entityProgram,
  newValue,
  onClose,
}: Props) => {
  const enable = newValue === "Enabled";
  // Assuming `programs` is your list of all possible Program objects
  const selectedProgram = allPrograms?.find((program) => program.name === entityProgram);
  const [enableComplianceMutation] = useEnableComplianceMutation({
    refetchQueries: ["GetFilteredEntities"],
    onCompleted: () =>
      toast.success(
        `Successfully ${enable ? "enabled" : "disabled"} compliance program for entity ${entityName}`,
      ),
    onError: (e) => toast.error(e.message),
  });

  const setComplianceProgram = async () => {
    await enableComplianceMutation({
      variables: {
        arenaId: toGlobalId("ArenaObjectType", arenaId),
        entityId: entityId,
        enable: enable,
      },
    });
    onClose();
  };
  return (
    <ModalV2 show={showModal} onHide={onClose} isCentered={true} size="small" title="Warning">
      <Text>
        {`The compliance program ${selectedProgram?.name ?? "--"} will be ${enable ? "enabled" : "disabled"} for ${entityName}.`}
      </Text>
      <Flex
        justifyContent="flex-end"
        css={{ marginBottom: SPACING.MEDIUM, marginTop: SPACING.MEDIUM }}
      >
        <Button onClick={onClose} variant="neutral" css={{ marginRight: SPACING.MEDIUM }}>
          Cancel
        </Button>
        <Button onClick={setComplianceProgram} variant="primary">
          Enable compliance program
        </Button>
      </Flex>
    </ModalV2>
  );
};

export default EnableComplianceWarningModal;
